/**
 * @generated SignedSource<<4ae635e0e4634f6ea9cbfc7c6e23cdf0>>
 * @relayHash 545f444aaf5274101b6a492dce4cdb6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b289ca2f1d3807b2db74e7ab190beb6ba0f0e196b16fec755ef4206276a699b4

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type TownsquareProjectsRemoveJiraWorkItemLinkInput = {
  projectId: string;
  workItemId: string;
};
export type atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation$variables = {
  input: TownsquareProjectsRemoveJiraWorkItemLinkInput;
};
export type atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation$data = {
  readonly projects_removeJiraWorkItemLink: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation = {
  response: atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation$data;
  variables: atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TownsquareProjectsRemoveJiraWorkItemLinkPayload",
        "kind": "LinkedField",
        "name": "projects_removeJiraWorkItemLink",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TownsquareProjectsRemoveJiraWorkItemLinkPayload",
        "kind": "LinkedField",
        "name": "projects_removeJiraWorkItemLink",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b289ca2f1d3807b2db74e7ab190beb6ba0f0e196b16fec755ef4206276a699b4",
    "metadata": {},
    "name": "atlasProject_issueFieldAtlasProject_AtlasProjectField_UnlinkProjectFromWorkItemMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "81a581954454862ea2506465764ef409";

export default node;
